import appConfig from '../../configs/appConfig';
import marketCodes from '../../consts/localization/marketCodes';
import QUERY_PARAMS from '../../consts/route/queryParams';
import iapClientService from '../iap/iapClientService';
import log from '../logger/log';
import storageService from '../storageService';
import localizationService from './localizationService';

const fetchCountryCode = async () => {
    try {
        const response = await iapClientService.getIapCountryCode();

        storageService.setApiCountryCodeToLocalStorage(response);

        return response;
    } catch (e) {
        log.error('localizationCountryService: Error fetching country code:', e);
    }
};

const getGeoRestrictionValue = () => {
    const grValueFromStorage = storageService.getGeoRestrictionFromLocalStorage();

    if (grValueFromStorage) {
        return grValueFromStorage;
    }

    const urlParams = new URLSearchParams(window.location.search);

    const grValueFromUrl = urlParams.get(QUERY_PARAMS.GEO_RESTRICTION);

    if (grValueFromUrl) {
        storageService.setGeoRestrictionToLocalStorage(grValueFromUrl);

        return grValueFromUrl;
    }
};

const getUserCountryCode = async () => {
    const geoRestrictionValue = getGeoRestrictionValue();

    if (geoRestrictionValue === 'false') {
        storageService.setCountryCodeToLocalStorage(marketCodes.PMI);
        return marketCodes.PMI;
    }

    const apiCountryCode = await fetchCountryCode();
    const isMarketSupported = appConfig.getIsMarketSupported(apiCountryCode);

    if (apiCountryCode && isMarketSupported) {
        storageService.setCountryCodeToLocalStorage(apiCountryCode);
        return apiCountryCode;
    }

    const fallbackMarketCode = localizationService.getFallbackMarketCode();

    storageService.setCountryCodeToLocalStorage(fallbackMarketCode);
    return fallbackMarketCode;
};

const getUserCountryCodeFromLocalStorage = () => storageService.getCountryCodeFromLocalStorage();

const getDeviceCountryCode = () => {
    const countryCode = storageService.getApiCountryCodeFromLocalStorage() || getUserCountryCodeFromLocalStorage();

    // Device only supports country codes up to 2 characters
    return countryCode?.slice(0, 2);
};

export default {
    getUserCountryCode,
    getUserCountryCodeFromLocalStorage,
    getDeviceCountryCode,
};
